(function () {
    'use strict';

    var accountRadios = document.querySelectorAll('input[type="radio"]'),
        accountButton = document.querySelector('.account .button');

    // Function to get the label for a specific radio button
    function getLabelForRadio(radio) {
        return radio.closest('label');
    }

    // Function to update the button text based on the label
    function updateButtonText(radio) {
        var label = getLabelForRadio(radio);
        if (label) {
            accountButton.value = label.textContent.trim();
        }
    }

    // Function to update the "checked" class for labels
    function updateCheckedClass(radio) {
        var label = getLabelForRadio(radio);

        // First remove the "checked" class from all labels
        accountRadios.forEach(function (input) {
            var l = getLabelForRadio(input);
            if (l) {
                l.classList.remove('checked');
            }
        });

        // Add "checked" class to the current label
        if (label) {
            label.classList.add('checked');
        }
    }

    // Combined function: update button text and "checked" class
    function updateUI(radio) {
        updateButtonText(radio);
        updateCheckedClass(radio);
    }

    // On page load: set button text and checked class based on the checked radio or the first one
    var initialRadio = document.querySelector('input[type="radio"]:checked') || accountRadios[0];
    if (initialRadio) {
        updateUI(initialRadio);
    }

    // On click: update the button text and "checked" class based on the clicked radio button
    accountRadios.forEach(function (radio) {
        radio.addEventListener('click', function () {
            updateUI(radio);
        });
    });

    // On page load remove parameter page from URL
    document.addEventListener('DOMContentLoaded', function() {
        const url = new URL(window.location);
        url.searchParams.delete('page');
        window.history.replaceState({}, '', url);
    });
    
})();

